import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const WTPPumpCategoryTableDataAPI = createAsyncThunk("WTPPumpCategoryTableData", async ({ data }) => {
    const {
        M_WTP_PumpCategoryID,
        M_UserID,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Master/Get_WEB_M_WTP_PumpCategory_Select?M_WTP_PumpCategoryID=${M_WTP_PumpCategoryID ? M_WTP_PumpCategoryID : 0}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data

            } else {
                return result
            }
        })
})

const WTPPumpCategoryTableDataSlice = createSlice({
    name: "WTPPumpCategoryTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPPumpCategoryTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPPumpCategoryTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WTPPumpCategoryTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WTPPumpCategoryTableDataReducer = WTPPumpCategoryTableDataSlice.reducer


export const WTPPumpCategoryPostDataAPI = createAsyncThunk("WTPPumpCategoryPostData", async ({ data }) => {
    const {
        M_WTP_PumpCategoryID,
        PumpCategory,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_WTP_PumpCategoryID", M_WTP_PumpCategoryID);
    formdata.append("PumpCategory", PumpCategory);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);


    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/Post_WEB_M_WTP_PumpCategory_InsertUpdate`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const WTPPumpCategoryPostDataSlice = createSlice({
    name: "WTPPumpCategoryPostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPPumpCategoryPostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPPumpCategoryPostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WTPPumpCategoryPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WTPPumpCategoryPostDataReducer = WTPPumpCategoryPostDataSlice.reducer

// -----------------Delete API ---------------

export const WTPPumpCategoryDeleteAPI = createAsyncThunk("WTPPumpCategoryDelete", async ({ data }) => {
    const {
        M_WTP_PumpCategoryID,
        M_UserID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);


    var formdata = new FormData();
    formdata.append("M_WTP_PumpCategoryID", M_WTP_PumpCategoryID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/WEB_M_WTP_PumpCategory_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const WTPPumpCategoryDeleteSlice = createSlice({
    name: "WTPPumpCategoryDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPPumpCategoryDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(WTPPumpCategoryDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(WTPPumpCategoryDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WTPPumpCategoryDeleteReducer = WTPPumpCategoryDeleteSlice.reducer